import FormAddQuestion from './FormQuestion/FormAddQuestion';
import {useContext} from 'react';
import {TestContext} from '../store/testContext';
import ButtonAddNewQuestion from '../components/TestsButtons/ButtonAddNewQuestion';

export default function AddQuestion() {
  const {
    state: {IsQuestionFormOpen}
  } = useContext(TestContext);

  return IsQuestionFormOpen ? <FormAddQuestion /> : <ButtonAddNewQuestion />;
}
